import React from "react";
import { ComponentExt } from "@src/utils/reactExt";
import * as styles from "./styles/index.scss"
import monthgiftbg from "@assets/img/monthgiftbg.png"
import monthTitle from "@assets/img/monthTitle.png"
import monthButton from "@assets/img/monthButton.png"
import bg0 from "@assets/img/bg0.png"
import bg1 from "@assets/img/bg1.png"
import bg2 from "@assets/img/bg2.png"
import bg3 from "@assets/img/bg3.png"
import norecord from "@assets/img/norecord.png"
import monthSuccess from "@assets/img/monthSuccess.png"
import { InputItem, Button } from 'antd-mobile'
import { createForm } from 'rc-form';
import { isValidPhone } from "@utils/index"
class Gift extends ComponentExt<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            info: '',
            color: '',
            success: false,
            remainingCycle: '',
            resDetailRecord: []
        }
    }
    doSubmit = () => {
        this.props.form.validateFields(async (error, value) => {
            if (!error) {
                if (!isValidPhone(value.phone)) {
                    return this.setState({ info: '请输入正确的手机号', color: '' })
                }
                try {
                    this.setState({ info: '', color: '' })
                    this.$toast.loading('领取中，请稍后', 15)
                    const remainingCycle = await this.api.queryMonthlySignDetail({ phone: value.phone })
                    console.log("remainingCycle", remainingCycle)
                    if (JSON.stringify(remainingCycle) == '{}') {
                        this.setState({ remainingCycle: '0' })
                    } else {
                        this.setState({ remainingCycle })
                    }

                    const resDetailRecord = await this.api.queryMonthlySignRecord({ phone: value.phone })
                    const { list = [] } = resDetailRecord;
                    this.setState({ resDetailRecord: list })
                    const res = await this.api.monthlySignGift({ phone: value.phone })
                    if (res) {
                        const remainingCycle2 = await this.api.queryMonthlySignDetail({ phone: value.phone })
                        if (JSON.stringify(remainingCycle2) == '{}') {
                            this.setState({ remainingCycle: '0' })
                        } else {
                            this.setState({ remainingCycle: remainingCycle2 })
                        }
                        const resDetailRecord2 = await this.api.queryMonthlySignRecord({ phone: value.phone })
                        const { list = [] } = resDetailRecord2;
                        this.setState({ resDetailRecord: list })
                    }
                    this.setState({ success: true })
                    this.$toast.hide()
                } catch (error) {
                }
            }
        })
    };
    render(): React.ReactNode {
        const { getFieldProps } = this.props.form;
        return (
            <div className={styles.giftWrapper} style={{ backgroundImage: `url(${monthgiftbg})` }}>
                <div className={styles.content} style={{ backgroundImage: `url(${bg0})` }}>
                    <div >
                        <div className={styles.title} style={{ backgroundImage: `url(${monthTitle})` }}>
                            <span> 活动赠礼</span>
                        </div>
                        {
                            !this.state.success &&
                            <>
                                <InputItem
                                    {...getFieldProps('phone',)}
                                    placeholder={'请输入手机号码'}
                                    className={styles.inputItem}
                                />
                                <p className={styles.giftInfo} style={{ color: this.state.color || 'red' }}>{this.state.info}</p>
                                <div className={styles.btn} style={{ backgroundImage: `url(${monthButton})` }} onClick={this.doSubmit}>立即领取</div>
                            </>
                        }
                        {
                            this.state.success && <>
                                <img src={monthSuccess} style={{ width: '3.7rem', marginBottom: '0.6rem' }} alt="" />
                            </>
                        }

                        <div className={styles.remainingCycle}>
                            <span style={{ color: '#FFDEC5' }}>活动可领取剩余周期：<span style={{ color: '#fff' }}>{this.state.remainingCycle || '---'}</span> </span>
                        </div>
                    </div>
                </div>
                <div className={styles.bg1} style={{ backgroundImage: `url(${bg1})` }}></div>
                <div className={styles.bg2} style={{ backgroundImage: `url(${bg2})` }}>

                    {this.state.resDetailRecord.length == 0 && <>
                        <img src={norecord} style={{ width: '2.8rem' }} alt="" />
                        <div className={styles.bg2_text}>暂无领取记录</div>
                    </>}
                    {this.state.resDetailRecord.length != 0 && <>
                        {
                            this.state.resDetailRecord.map((item: any, index) => {
                                return <div className={styles.resDetailRecord} style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #E8DFD7' }} key={index}>
                                    <div className={styles.resDetailRecord2}><div className={styles.resDetailRecord1}></div>{item}</div>
                                    <div className={styles.resDetailRecord3}>1500GB领取成功</div>
                                </div>
                            })
                        }
                    </>}
                </div>
                <div className={styles.bg3} style={{ backgroundImage: `url(${bg3})` }}>
                    <div className={styles.title1}>活动规则</div>
                    <div className={styles.title2}>1、活动期间用户关注公众号后即可在活动页面输入绑定的手机号参与活动； </div>
                    <div className={styles.title2}>2、可每月进行签到领取千G流量套餐，每个账号可连续签到领取12个月。 </div>
                    <div className={styles.title1} style={{ marginTop: '0.2rem' }}>活动说明</div>
                    <div className={styles.title2}>1、千G流量套餐为1500GB*1个月，签到领取后将直接下发到账号绑定的号卡并在当前自然月生效；</div>
                    <div className={styles.title2}>2、参与活动进行签到前，请确认已实名激活电脑原流量套餐，激活后活动内套餐方可正常下发。 </div>
                </div>
            </div>
        )
    }
}
export default createForm()(Gift)